import { useEffect, useState } from 'react';
import api from "../services/axiosInstance";
import { backendPort } from '../components/Fungsiku'; 
import { PageKonten9_Show } from './Page9_Show';
import { PageKonten9_Edit } from './Page9_Edit';
import { ShowPic } from '../components/ShowPic';


//MASTER KENDARAAN
export function PageKonten9({globalOpsi, authIdentity = {}, setPage, reloadToken = 0}) {
  const opsiCabang = globalOpsi.opsiCabang;
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const PAGE_SIZE_OPTIONS = [5, 10, 20];
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const dataKosong = {
    id_mt: '', 
    nopol: '', 
    kode_cabang:'', 
    merk: '', 
    transportir: '',
    kapasitas:'',
    kategori:'',
    status:'',  
    roda: '',
    cadangan: '',
    tahun_pembuatan:'',
    kir: '',
    catatan_ban_initial: '',
    tanggal : '',
    user: '',
    odo_awal: '' //daily_mt
  };
  const [showDetail, setShowDetail] = useState(false);
  //const [kodeNew, setKodeNew] = useState('');
  const [sortBy, setSortBy] = useState('id_mt');
  const [sortDir, setSortDir] = useState('asc'); // asc | desc
  const [showEdit, setShowEdit] = useState(false);
  const [showMaster, setShowMaster] = useState(true);
  const [editData, setEditData] = useState(dataKosong);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchBy, setSearchBy] = useState('all');
  const [filterCabang, setFilterCabang] = useState(kodeCabangUser);
  const [page, setTabelPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [refreshToken, setRefreshToken] = useState(0);
  const [openLampiranModal, setOpenLampiranModal] = useState(false);
  const [selectedLampiranFiles, setSelectedLampiranFiles] = useState([]);
  const [dashboardTargetMt, setDashboardTargetMt] = useState("");
  const [holdCabangAutoSync, setHoldCabangAutoSync] = useState(false);

  const parseLampiran = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(String(search || "").trim());
    }, 350);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    setTabelPage(1);
  }, [filterCabang, searchBy, debouncedSearch, pageSize, sortBy, sortDir]);

  useEffect(() => {
    if (!kodeCabangUser) return;
    if (holdCabangAutoSync) return;
    setFilterCabang(kodeCabangUser);
    setTabelPage(1);
  }, [kodeCabangUser, holdCabangAutoSync]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const idMt = String(window.__dashboard_picker_state?.id_mt || "").trim();
    if (!idMt) return;
    setHoldCabangAutoSync(true);
    setDashboardTargetMt(idMt);
    setFilterCabang("");
    setSearchBy("id_mt");
    setSearch(idMt);
    setDebouncedSearch(idMt);
    setTabelPage(1);
    const prev = window.__dashboard_picker_state || {};
    window.__dashboard_picker_state = { ...prev, id_mt: "" };
  }, []);

  useEffect(() => {
    if (!dashboardTargetMt || !showMaster) return;
    const targetUpper = String(dashboardTargetMt || "").trim().toUpperCase();
    const match = (Array.isArray(rows) ? rows : []).find((r) => String(r?.id_mt || "").trim().toUpperCase() === targetUpper);
    if (!match) return;
    show(match);
    setDashboardTargetMt("");
    setHoldCabangAutoSync(false);
  }, [dashboardTargetMt, rows, showMaster]);

  useEffect(() => {
    let ignore = false;
    const loadData = async () => {
      setLoading(true);
      try {
        const payload = {
          page,
          pageSize,
          kodeCabang: filterCabang,
          searchBy,
          keyword: debouncedSearch,
          sortBy,
          sortDir,
        };
        const { data } = await api.post(`${backendPort}/api/main/load_page9_mt_list`, payload);
        if (ignore) return;
        const nextRows = Array.isArray(data?.rows) ? data.rows : [];
        setRows(nextRows.map((x) => ({
          ...x,
          lampiran: parseLampiran(x?.lampiran),
          lampiran_mt_event: x?.lampiran_mt_event || '',
        })));
        setTotalRows(Number(data?.total || 0));
      } catch (err) {
        console.error(err);
        if (!ignore) {
          setRows([]);
          setTotalRows(0);
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    };
    loadData();
    return () => {
      ignore = true;
    };
  }, [page, pageSize, filterCabang, searchBy, debouncedSearch, sortBy, sortDir, reloadToken, refreshToken]);

  const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
  const currentPage = Math.min(page, totalPages);

  const openLampiran = (row) => {
    const listLampiran = Array.isArray(row?.lampiran) ? row.lampiran : [];
    const files = listLampiran
      .filter((item) => Boolean(item?.path))
      .map((item, idx) => ({
        url: String(item.path).startsWith("http")
          ? item.path
          : `${backendPort}${item.path}`,
        caption: item?.caption || item?.name || `Lampiran ${idx + 1}`,
        name: item?.name || `Lampiran ${idx + 1}`,
        note: `${row?.id_mt || ""} - ${item?.caption || item?.name || `Lampiran ${idx + 1}`}`.trim(),
      }));
    if (files.length === 0) return;
    setSelectedLampiranFiles(files);
    setOpenLampiranModal(true);
  };

  function show(row){
    setShowDetail(true);
    setShowMaster(false);                          
    setEditData({
      id_mt: row.id_mt,
      nopol: row.nopol,
      kode_cabang: row.kode_cabang_aktif ?? row.kode_cabang, 
      merk: row.merk,
      transportir: row.transportir,
      kapasitas : row.kapasitas,
      kategori : row.kategori,
      status : row.status,
      roda : row.roda,
      cadangan : row.cadangan, 
      tahun_pembuatan: row.tahun_pembuatan,
      kir : row.kir,
      odo_awal : row.odo_awal,
      catatan_ban_initial : row.catatan_ban_initial ?? row.catatan_mt ?? '',
      tanggal : row.tanggal,
      user : row.user,
      lampiran: row.lampiran ?? [],
      lampiran_mt_event: row.lampiran_mt_event || ''
    })
  }

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortBy(field);
      setSortDir('asc');
    }
  };

  return (
      <div className="container-fluid page9-surface page9-table-theme">
      <ShowPic
        open={openLampiranModal}
        onClose={() => setOpenLampiranModal(false)}
        row={{ catatan: selectedLampiranFiles?.[0]?.caption || "" }}
        backendPort={backendPort}
        token=""
        onUploadSuccess={() => {}}
        readOnly={true}
        customTitle="Lampiran MT"
        customNote={selectedLampiranFiles?.[0]?.caption || ""}
        customFileUrl={selectedLampiranFiles?.[0]?.url || null}
        customFiles={selectedLampiranFiles}
      />
      {/* PopUp */}
        
      <div className="row">
                {/* TABLE */}
        {showMaster &&
        <div className="col-md-12">
          <div className='d-flex justify-content-end mb-2'>
          </div>
          <div className="card page9-card rounded-4">
            <div className="card-header d-flex justify-content-between align-items-center page9-card-header ">
            <div>
              <div className="page9-title text-white">Daftar Kendaraan</div>
            </div>
            </div>

            <div className="card-body page9-card-body">
              <div className="row g-3 page9-filter-row mb-3">
                <div className="col-12 col-md-3">
                  <label className="page9-label">Cabang</label>
                  <select
                    className="form-select"
                    value={filterCabang}
                    onChange={(e) => {
                      setFilterCabang(e.target.value);
                      setTabelPage(1);
                    }}
                  >
                    <option value={""}>Semua Cabang</option>
                    {opsiCabang.map((x) => (
                      <option key={x.kode_cabang} value={x.kode_cabang}>{x.nama_cabang}</option>
                    ))}
                  </select>
                </div>

                <div className="col-12 col-md-3">
                  <label className="page9-label">Cari Berdasarkan</label>
                  <select
                    className="form-select"
                    value={searchBy}
                    onChange={(e) => {
                      setSearchBy(e.target.value);
                      setTabelPage(1);
                    }}
                  >
                    <option value={"all"}>Semua Kolom</option>
                    <option value={"nopol"}>No. Polisi</option>
                    <option value={"id_mt"}>ID Kendaraan</option>
                    <option value={"merk"}>Merk</option>
                    <option value={"transportir"}>Transportir</option>
                    <option value={"tahun_pembuatan"}>Tahun</option>
                    <option value={"kapasitas"}>Kapasitas</option>
                    <option value={"kategori"}>Kategori</option>
                    <option value={"cabang"}>Cabang</option>
                    <option value={"status"}>Status</option>
                  </select>
                </div>

                <div className="col-12 col-md-4">
                  <label className="page9-label">Kata Kunci</label>
                  <input
                    className="form-control"
                    placeholder="Cari data kendaraan..."
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setTabelPage(1);
                    }}
                  />
                </div>

                <div className="col-12 col-md-2">
                  <label className="page9-label">Baris</label>
                  <select
                    className="form-select"
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                      setTabelPage(1);
                    }}
                  >
                    {PAGE_SIZE_OPTIONS.map((x) => (
                      <option key={x}>{x}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="page9-table-wrap">
              <table className="table table-bordered table-hover page9-table table-theme-uniform">
                <thead>
                  <tr>
                    <th onClick={() => handleSort('id_mt')} style={{ cursor: 'pointer' }}>
                      <div className="flex justify-content-between align-items-center">
                        <span>Id MT</span>
                        {sortBy === 'id_mt' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>

                    <th onClick={() => handleSort('cabang')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Cabang</span>
                        {sortBy === 'cabang' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>

                    <th onClick={() => handleSort('nopol')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>No. Polisi</span>
                        {sortBy === 'nopol' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>

                    <th>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Merk</span>
                      </div>
                    </th>

                    <th onClick={() => handleSort('transportir')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Transportir</span>
                        {sortBy === 'transportir' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>
                    
                    <th>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Tahun</span>
                      </div>
                    </th>    

                    <th>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Kapasitas</span>
                      </div>
                    </th>

                    <th>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Kategori</span>
                      </div>
                    </th>
                    <th width="120">Lampiran</th>
                    <th width="80">Aksi</th>
                 
                  </tr>
                </thead>
                <tbody>
                    {loading && (
                      <tr>
                        <td colSpan={10}><div className='my-4 text-center'>Memuat data...</div></td>
                      </tr>
                    )}
                    {!loading && rows.length === 0 ? <tr><td colSpan={10}><div className='my-4 text-center'>Tidak Ada Data</div></td></tr>
                       : !loading && rows.map((row) => (
                      <tr key={row.id_mt}>
                        <td className='single-line'>{row.id_mt}</td>
                        <td className='single-line'>{row.nama_cabang}</td>
                        <td className='single-line'>{row.nopol}</td>
                        <td className='single-line'>{row.merk}</td>
                        <td className='single-line'>{row.transportir || '-'}</td>
                        <td className='single-line'>{row.tahun_pembuatan}</td>
                        <td className='single-line'>{row.kapasitas}</td>
                        <td className='single-line'>{row.kategori}</td>
                        <td className="text-center">
                          {Array.isArray(row.lampiran) && row.lampiran.length > 0 ? (
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary page9-lampiran-btn"
                              onClick={() => openLampiran(row)}
                            >
                              <i className="fa fa-paperclip me-1"></i>
                              {row.lampiran.length}
                            </button>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td className="text-center">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => show(row)}
                          >
                            Lihat
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              </div>
            </div>
            {/* PAGINATION NAV */}
            <div className="d-flex justify-content-between align-items-center my-2 mx-3 page9-pagination">
            <div>
              {`Total: ${totalRows} kendaraan`}
            </div>

            <nav>
              <ul className="pagination mb-0">
                <li className={`page-item ${currentPage <= 1 && "disabled"}`}>
                  <button
                    className="page-link"
                    disabled = {currentPage <= 1}
                    onClick={() => setTabelPage((p) => Math.max(1, p - 1))}
                  >
                    Prev
                  </button>
                </li>
                <li className="page-item">
                  <button className="page-link" disabled>{`${currentPage} / ${totalPages}`}</button>
                </li>

                <li
                  className={`page-item ${
                    currentPage >= totalPages && "disabled"
                  }`}
                >
                  <button
                    className="page-link"
                    disabled={currentPage >= totalPages}
                    onClick={() => setTabelPage((p) => Math.min(totalPages, p + 1))}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          </div>
        </div>
        }          

        {showDetail 
          && <PageKonten9_Show 
          opsiCabang = {opsiCabang} 
          editData = {editData} 
          setShowDetail = {setShowDetail} 
          setShowMaster = {setShowMaster}
          globalOpsi = {globalOpsi}
          reloadToken={reloadToken} />}

        {/* FORM Edit*/}
        {showEdit && <PageKonten9_Edit
          statusAksi={'edit'}
          data ={editData} 
          loadData={() => setRefreshToken((prev) => prev + 1)}
          authIdentity={authIdentity}
          setShowEdit = {setShowEdit}
          setShowMaster = {setShowMaster}
          setPage={setPage}
          reloadToken={reloadToken}
        />}            
      </div>
      </div>
  );
}
